import React from 'react';
import { Server, Cloud, Terminal, Shield, Database, Cpu, Building2, BarChart3 } from 'lucide-react';
import ServiceCard from './ServiceCard';

const Services: React.FC = () => {
  const services = [
    {
      icon: <Server className="w-8 h-8 text-blue-400" />,
      title: "Web Hosting",
      description: "High-performance hosting solutions with 99.9% uptime, advanced security, and 24/7 technical support.",
      features: ["SSD Storage", "Free SSL", "Daily Backups", "CDN Integration"]
    },
    {
      icon: <Cloud className="w-8 h-8 text-teal-400" />,
      title: "Cloud Support",
      description: "Expert cloud infrastructure management and optimization for AWS, Azure, and Google Cloud platforms.",
      features: ["Architecture Design", "Migration Services", "Cost Optimization", "Auto-scaling"]
    },
    {
      icon: <Terminal className="w-8 h-8 text-purple-400" />,
      title: "DevOps Support",
      description: "End-to-end DevOps services to streamline your development workflow and deployment pipelines.",
      features: ["CI/CD Pipelines", "Container Orchestration", "Infrastructure as Code", "Monitoring"]
    },
    {
      icon: <Building2 className="w-8 h-8 text-orange-400" />,
      title: "Business Management Solutions",
      description: "Transform your offline business operations into efficient digital workflows and management systems.",
      features: ["Digital Transformation", "Process Automation", "Custom Software", "Training & Support"]
    },
    {
      icon: <BarChart3 className="w-8 h-8 text-emerald-400" />,
      title: "Online Business Growth",
      description: "Comprehensive solutions to establish and grow your online business presence and operations.",
      features: ["E-commerce Solutions", "Business Analytics", "Digital Marketing", "Customer Management"]
    },
    {
      icon: <Shield className="w-8 h-8 text-red-400" />,
      title: "Security",
      description: "Comprehensive security solutions to protect your applications and infrastructure from threats.",
      features: ["Vulnerability Scanning", "DDoS Protection", "WAF Implementation", "Security Audits"]
    },
    {
      icon: <Database className="w-8 h-8 text-yellow-400" />,
      title: "Database Management",
      description: "Expert database administration, optimization, and support for SQL and NoSQL databases.",
      features: ["Performance Tuning", "High Availability", "Backup & Recovery", "Migration Services"]
    },
    {
      icon: <Cpu className="w-8 h-8 text-green-400" />,
      title: "Infrastructure Optimization",
      description: "Optimize your IT infrastructure for performance, scalability, and cost-efficiency.",
      features: ["Resource Utilization", "Performance Analysis", "Cost Reduction", "Scalability Planning"]
    }
  ];

  return (
    <section id="services" className="py-20 bg-slate-950">
      <div className="container mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-3 py-1 bg-slate-800/60 backdrop-blur-sm rounded-full text-teal-400 font-medium text-sm mb-4">
            Our Services
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Comprehensive Tech Solutions
          </h2>
          <p className="text-slate-300">
            We provide end-to-end technical services to help businesses build, manage, 
            and optimize their digital infrastructure and operations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <ServiceCard key={index} service={service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;